import { navItems, snsLinks, siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 px-5 pb-10 pt-16 pr-14 md:px-10 md:pt-20 md:pr-16">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col gap-10 border-b border-background-50/10 pb-10 md:flex-row md:items-start md:justify-between">
          <div>
            <p className="font-heading text-2xl font-black tracking-[0.06em] text-background-50 md:text-3xl">
              H.Y企画
            </p>
            <p className="mt-3 text-[10px] en-label text-background-50/45">TRIAL FESTA / KUMAMOTO</p>
            <p className="mt-5 max-w-sm text-[13px] leading-relaxed text-background-50/55">
              主催：{siteInfo.organizer}　運営：{siteInfo.operator}
              <br />
              {siteInfo.areaNote}
            </p>
          </div>

          <div className="flex flex-col gap-8 sm:flex-row sm:gap-14">
            <nav aria-label="フッターメニュー">
              <p className="text-[10px] en-label text-background-50/40">MENU</p>
              <ul className="mt-4 space-y-2.5">
                {navItems.map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      className="cursor-pointer text-[13px] text-background-50/70 transition-colors duration-300 hover:text-background-50"
                    >
                      {item.jp}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>

            <div>
              <p className="text-[10px] en-label text-background-50/40">SNS</p>
              <ul className="mt-4 space-y-2.5">
                {snsLinks.map((sns) => (
                  <li key={sns.name}>
                    {sns.available ? (
                      <a
                        href={sns.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex cursor-pointer items-center gap-2 text-[13px] text-background-50/70 transition-colors duration-300 hover:text-background-50"
                      >
                        <i className={`${sns.icon} text-sm`} aria-hidden="true" />
                        {sns.name}
                      </a>
                    ) : (
                      <span className="inline-flex items-center gap-2 text-[13px] text-background-50/30">
                        <i className={`${sns.icon} text-sm`} aria-hidden="true" />
                        {sns.name}（準備中）
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-3 pt-7 text-[11px] text-background-50/35 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 H.Y企画 / 運営 炭乃家</p>
          <p>掲載内容は決定次第、随時更新いたします。</p>
        </div>
      </div>
    </footer>
  );
}